<template>
  <div
    class="transaction-types"
    v-click-outside="hideList"
    :class="{ opened: listToggled }"
    @click="openList"
  >
    <div class="transaction-types__header">
      <div class="transaction-types__selected" v-if="!selectedType">
        {{ $t('transaction-types-select.all-types') }}
      </div>
      <div class="transaction-types__selected" v-else>
        {{ $t(`${selectedType.name}`) }}
      </div>
      <div class="transaction-types__header-arrow">
        <svg
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="25"
            height="25"
            rx="8.5"
            transform="matrix(0 1 1 0 0 0)"
            stroke="#E0E6F2"
          />
          <path
            d="M12.6491 15.5243L9.12646 12.0016C9.04492 11.9201 9 11.8114 9 11.6954C9 11.5794 9.04492 11.4706 9.12646 11.3892L9.38582 11.1297C9.55483 10.9609 9.8295 10.9609 9.99825 11.1297L12.9564 14.0879L15.9178 11.1265C15.9993 11.045 16.108 11 16.2239 11C16.34 11 16.4487 11.045 16.5303 11.1265L16.7896 11.3859C16.8711 11.4674 16.916 11.5761 16.916 11.6921C16.916 11.8081 16.8711 11.9168 16.7896 11.9983L13.2637 15.5243C13.1819 15.606 13.0727 15.6509 12.9566 15.6506C12.84 15.6509 12.7309 15.606 12.6491 15.5243Z"
            fill="#666D79"
          />
        </svg>
      </div>
    </div>
    <div class="transaction-types__list" v-if="listToggled">
      <div
        class="transaction-types__item transaction-types__item--all"
        @click="selectType(null)"
        :class="{ active: selectedType === null }"
      >
        <div class="transaction-types__item-name">
          {{ $t('transaction-types-select.all-types') }}
        </div>
      </div>
      <div
        class="transaction-types__item"
        v-for="type in availableTypes"
        :key="`operation-type-${type.id}`"
        :class="{
          active: selectedType !== null && selectedType.id === type.id,
        }"
        @click="selectType(type)"
      >
        <div class="transaction-types__item-name">
          {{ $t(type.name) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
import { TRANSACTION_TYPES } from '@js-app/const/transaction-types'

export default {
  name: 'TransactionTypesSelect',
  props: {
    selectedType: {
      type: Object,
      default: null,
    },
    availableTypes: {
      type: Object,
      default() {
        return TRANSACTION_TYPES
      },
    },
  },
  data() {
    return {
      listToggled: false,
    }
  },
  methods: {
    selectType(transactionType) {
      $emit(this, 'typeChanged', transactionType)
    },
    hideList() {
      this.listToggled = false
    },
    openList() {
      this.listToggled = !this.listToggled
    },
  },
  emits: ['typeChanged'],
}
</script>

<style lang="scss" scoped>
.transaction-types {
  position: relative;
  &.opened & {
    &__header {
      &-arrow {
        transform: rotate(180deg);
      }
    }
  }

  &__header {
    display: flex;
    align-items: center;
    cursor: pointer;

    &-arrow {
      margin-left: 10px;
      width: 26px;
      height: 26px;

      display: flex;
      align-items: center;
      justify-content: center;
      transition: transform 0.2s linear;

      svg {
        width: 100%;
        height: 100%;
      }
    }
  }

  &__selected {
    font-weight: 500;
    font-size: 12px;
    line-height: 28px;
    color: #585f6d;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  &__list {
    top: calc(100% + 19px);
    left: -29px;
    width: 202px;
    position: absolute;
    padding: 19px 0;
    background: #ffffff;
    box-shadow: 0px -5px 60px rgba(120, 140, 184, 0.1);
    border-radius: 8px;
    z-index: 99;
  }

  &__item {
    display: flex;
    align-items: center;
    padding: 10px 15px 10px 21px;
    cursor: pointer;
    transition: background 0.2s linear;
    margin-bottom: 5px;

    &:last-child {
      margin-bottom: 0;
    }

    &:hover,
    &.active {
      background: rgba(#e0e6f2, 0.5);
    }

    &:hover &,
    &.active & {
      &-name {
        color: #64748B;
      }
    }

    &--all {
      font-weight: 500;
      font-size: 12px;
      line-height: 15px;
      display: flex;
      align-items: center;
      color: #666d79;
      transition: color 0.2s linear;
    }

    &-name {
      font-weight: 500;
      font-size: 12px;
      line-height: 15px;
      display: flex;
      align-items: center;
      color: #666d79;
      transition: color 0.2s linear;
    }
  }
}
@media screen and (max-width: 992px) {
  .transaction-types {
    &__list {
      left: 0;
    }
  }
}
</style>
